import axios from 'axios';
import { ANALYZER_API_URL } from '../constants/api';

const base = `${ANALYZER_API_URL}/lspiv`;

// nginx перед сервисом пропускает тело запроса не больше 1 МБ,
// поэтому видео уходит кусками меньше этого лимита.
const CHUNK_SIZE = 768 * 1024;
const CHUNK_RETRIES = 3;

const LspivService = {
    // ---------- job lifecycle ----------
    async createJob() {
        const { data } = await axios.post(`${base}/jobs`);
        return data;
    },
    async listJobs() {
        const { data } = await axios.get(`${base}/jobs`);
        return data.jobs;
    },
    async getJob(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}`);
        return data;
    },
    async deleteJob(jobId) {
        const { data } = await axios.delete(`${base}/jobs/${jobId}`);
        return data;
    },

    // ---------- video / frames ----------
    // После загрузки сервер сам извлекает кадры (статус extract-frames → frames-ready).
    async uploadVideo(jobId, file, onProgress) {
        for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
            const chunk = file.slice(offset, offset + CHUNK_SIZE);
            for (let attempt = 1; ; attempt++) {
                try {
                    await axios.post(`${base}/jobs/${jobId}/video/chunk`, chunk, {
                        params: { offset },
                        headers: { 'Content-Type': 'application/octet-stream' },
                    });
                    break;
                } catch (err) {
                    if (attempt >= CHUNK_RETRIES) throw err;
                }
            }
            if (onProgress) {
                onProgress(Math.round((Math.min(offset + CHUNK_SIZE, file.size) * 100) / file.size));
            }
        }
        const { data } = await axios.post(`${base}/jobs/${jobId}/video/complete`, {
            filename: file.name,
            size: file.size,
        });
        return data;
    },
    frameUrl(jobId, name) {
        return `${base}/jobs/${jobId}/frames/${name}`;
    },

    // ---------- расчёт ----------
    async run(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/run`, body);
        return data;
    },
    async getResult(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}/result`);
        return data;
    },
    async getRunParams(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}/run-params`);
        return data;
    },
};

export default LspivService;
